export default __webpack_public_path__ + "static/feathers-ae313a68b4f5159f2a027a541550879b.png";